import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { ComponentsModule } from 'src/app/components/components.module';
import { OperationWithdrawalComponent } from './operation-withdrawal.component';
import { AddOthersBeneficiariesComponent } from './psa-add-beneficiary/psa-add-beneficiary.component';
import { ModalDetailsRetirementComponent } from './modals/modal-details-retirement/modal-details-retirement.component';
import { WithdrawalResultModalModule } from './modals/modal-success-retirement/withdrawal-result-modal.module';
import { B3DesignSystemWebModule } from 'src/app/shared/b3-design-system-web/b3-design-system-web.module';

@NgModule({
  declarations: [
    OperationWithdrawalComponent,
    AddOthersBeneficiariesComponent,
    ModalDetailsRetirementComponent,
  ],
  imports: [
    CommonModule,
    RouterModule,
    ReactiveFormsModule,
    FormsModule,
    ComponentsModule,
    B3DesignSystemWebModule,
    WithdrawalResultModalModule,
  ],
  exports: [OperationWithdrawalComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class OperationWithdrawalModule {}
